<template>
  <BjDrawerForm
    ref="BjDrawerForm"
    :form="form"
    label-width="120px"
    width="800px"
    @handleConfirm="handleConfirm"
  >
    <BjDivider>
      <!-- <template #right>
        <el-button>采购单强制关闭</el-button>
      </template> -->
    </BjDivider>

    <template>
      <el-table :data="tableData" border script style="width: 100%">
        <el-table-column label="SKU" prop="skuCode" align="center"> </el-table-column>
        <el-table-column :label="$t('BusinessPurchaseOrderList.dataForm.Purchase')" prop="planQty" align="center"> </el-table-column>
        <el-table-column :label="$t('BusinessPurchaseOrderList.dataForm.received')" prop="alreadyQty" align="center" width="173"> </el-table-column>
        <el-table-column :label="$t('BusinessPurchaseOrderList.dataForm.Difference')" prop="difference" align="center">
          <template #default="scope">{{ scope.row.planQty - scope.row.alreadyQty }}</template>
        </el-table-column>
        <el-table-column :label="$t('BusinessPurchaseOrderList.dataForm.tolerant')" prop="dataFaultToleranceQty" align="center">
          <template #default="scope">
            <BjInputNumber v-model="scope.row.dataFaultToleranceQty" />
          </template>
        </el-table-column>
      </el-table>
    </template>
  </BjDrawerForm>
</template>
<script>
import { purchaseApi } from '@/api';

const getDefaultForm = () => {
  return {
    channelWarehouseName: null,
  };
};

export default {
  components: {},
  data() {
    return {
      tableData: [],
      form: getDefaultForm(),
    };
  },
  computed: {},
  mounted() {},
  methods: {
    show(info) {
      this.tableData = info.goodsList || [];
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(this.$t('BusinessPurchaseOrderList.dataForm.fault'));
      this.form = Object.assign(getDefaultForm(), info || {});
    },
    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      this.addApi(API_DATA);
    },
    reFresh() {
      this.$emit('reFresh');
    },
    // 确定
    addApi(API_DATA) {
      const data = API_DATA.goodsList.map(e => e.dataFaultToleranceQty);
      if (data.length) {
        if (data.includes(undefined) || data.includes(0)) {
          this.$message.success(this.$t('BusinessPurchaseOrderList.dataForm.empty'));
        } else {
          this.editPurchase(API_DATA);
        }
      } else {
        if (data == undefined || data == 0) {
          this.$message.success(this.$t('BusinessPurchaseOrderList.dataForm.empty'));
        } else {
          this.editPurchase(API_DATA);
        }
      }
    },
    // 修改采购单
    editPurchase(API_DATA) {
      purchaseApi.putPurchases(API_DATA).then(res => {
            if (res.failed === false) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                this.$refs.BjDrawerForm.hide();
                this.reFresh();
              }, 500);
            }
          });
    }
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
